import { functions } from '../firebase';

const deleteAtPath = (path) => {
  const deleteFn = functions.httpsCallable('recursiveDelete');
  deleteFn({ path: path })
  .then(result => {
    console.log('Delete success: ' + JSON.stringify(result));
  })
  .catch(error => {
    console.warn(error);
  });
}

export default deleteAtPath;
